import ENV_PROD from './env.production';
import ENV_LOCAL from './env.local';
import ENV_PREPROD from './env.preprod';

// APP_ENV is only set (to 'preprod') by the preprod webpack build, independent
// of __DEV__/mode -- that build also runs with mode=development (same as
// local dev-server), so __DEV__ alone can't tell preprod and local dev apart.
const BASE =
  process.env.APP_ENV === 'preprod'
    ? ENV_PREPROD
    : __DEV__
      ? ENV_LOCAL
      : ENV_PROD;

// `npm run web -- --env apiProxy=https://api.circlechess.com` runs the local
// UI against a deployed API. The API base becomes relative so the calls go to
// the dev server, which forwards them; pointing CHESS_API_URL straight at the
// API instead would make the browser issue cross-origin requests that the API
// refuses — every localhost entry in its CORS_ALLOWED_ORIGINS carries a
// trailing slash, which never matches the Origin a browser actually sends.
//
// '/' rather than the proxy URL: an absolute URL would be cross-origin again
// and defeat the whole arrangement. '/' rather than '' because callers mix
// leading-slash and bare paths ('/video_learning/courses/' vs
// 'auth/v1/send_otp'), and only '/' resolves both to the site root — a bare
// path against an empty base resolves against the *current page*, so signing
// in from /masterclass would POST to /masterclass/auth/v1/send_otp.
//
// Both clients, not just one: login goes through CHAT_API_URL, and a page you
// cannot sign in to is no use whatever the other calls do.
const ENV = process.env.API_PROXY
  ? {...BASE, CHESS_API_URL: '/', CHAT_API_URL: '/'}
  : BASE;

export default ENV;
